import { api } from '@/api';
import { ActionContext } from 'vuex';
import { State } from '../state';
import { InvoiceState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { dispatchCheckApiError } from '../main/actions';
import { commitRemoveInvoice } from './mutations';
import { commitAddNotification, commitRemoveNotification } from '../main/mutations';
import { IInvoiceCreate } from '@/interfaces';
import { i18n } from '@/plugins/i18n';

type MainContext = ActionContext<InvoiceState, State>;

export const actions = {
  async actionCreateInvoice(context: MainContext, payload: {invoice: IInvoiceCreate, invoiceCustomerId: number | null}) {
    try {
      const loadingNotification = { content: String(i18n.t('common.save')), showProgress: true };
      commitAddNotification(context, loadingNotification);
      const locale = ['nl', 'fr', 'en'].includes(i18n.locale) ? i18n.locale : 'nl';
      const response = (await Promise.all([
        api.createInvoice(payload.invoice, payload.invoiceCustomerId, locale),
        await new Promise<void>((resolve) => setTimeout(() => resolve(), 500)),
      ]))[0];
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, { content: String(i18n.t('invoices.invoiceCreated')), color: 'success' });
      return response.data
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionEmailInvoice(context: MainContext, id: number) {
    try {
      const loadingNotification = { content: String(i18n.t('common.sendingEmail')), showProgress: true };
      commitAddNotification(context, loadingNotification);
      const response = (await Promise.all([
        api.emailInvoice(id),
        await new Promise<void>((resolve) => setTimeout(() => resolve(), 500)),
      ]))[0];
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, { content: String(i18n.t('invoices.invoiceSent')), color: 'success' });
      return response.data
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteInvoice(context: MainContext, payload: { id: number }) {
    try {
      const loadingNotification = { content: String(i18n.t('common.delete')), showProgress: true };
      commitAddNotification(context, loadingNotification);
      await Promise.all([
        api.deleteInvoice(payload.id),
        await new Promise<void>((resolve) => setTimeout(() => resolve(), 500)),
      ]);
      commitRemoveInvoice(context, payload.id);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, { content: String(i18n.t('invoices.invoiceDeleted')), color: 'success' });
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
};

const { dispatch } = getStoreAccessors<InvoiceState, State>('');

export const dispatchCreateInvoice = dispatch(actions.actionCreateInvoice);
export const dispatchDeleteInvoice = dispatch(actions.actionDeleteInvoice);
export const dispatchEmailInvoice = dispatch(actions.actionEmailInvoice)